import React from 'react';
import PropTypes from 'prop-types';
import useEffect from '@/util/hook/useEffect';
import useState from '@/util/hook/useState';
import { ANIMATION_MAP, S } from './style';
/**
 * This component is designed for handling the animation effect of its children,
 * especially the CSS transition between mounting and unmounting.
 * @param isShow - Used for controlling the rendering and animation effect
 * @param children - Child components
 * @param animationType - Please reference 'ANIMATION_TYPE_MAP'
 * @param customStyle - Customized style of the component
 */
export default function Animation({ isShow, children, animationType, customStyle = '', onAnimationEndExtraHandler, }) {
    const [shouldRender, setShouldRender] = useState(isShow);
    const animation = ANIMATION_MAP[animationType];
    useEffect(() => {
        if (isShow) {
            setShouldRender(true);
        }
    }, [isShow]);
    const onAnimationEnd = () => {
        if (!isShow) {
            setShouldRender(false);
            if (onAnimationEndExtraHandler)
                onAnimationEndExtraHandler();
        }
    };
    return shouldRender ? (<S.Animation isShow={isShow} animation={animation} customStyle={customStyle} onAnimationEnd={onAnimationEnd}>
      {children}
    </S.Animation>) : null;
}
Animation.propTypes = {
    isShow: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
    animationType: PropTypes.oneOf(Object.keys(ANIMATION_MAP)),
    customStyle: PropTypes.string,
    onAnimationEndExtraHandler: PropTypes.func,
};
